/*
	Wrap tables in side scrollable div
	Eligible tables:
	- do not have class: "responsive-table"
	- do not have class: "fees-table"
	- do not have class: "compare-table"
	- have at least 4 columns
*/

// Utilities
import debug from "debug";
const MODULE_NAME = 'table-side-scroller';
const log = debug(MODULE_NAME);
// Constants
const IGNORE_SELECTORS = ['.fees-table', '.responsive-table', '.compare-table', '[data-cu-pc-table]'];
const MIN_COLUMN_WIDTH = 4;
const WRAPPER_OPTIONS = {
	wrapperClass: 'table-side-scroller',
};

const tableCandidateTests = [
	hasColumns.bind(null, MIN_COLUMN_WIDTH),
	isNotMatchedBySelectors.bind(null, IGNORE_SELECTORS),
];

function hasColumns(count, table) {
	const firstContainer = table.querySelector(':scope > *:first-child');
	const cellSelector =
		firstContainer.tagName.toLowercase === 'tr'
			? ':scope > *'
			: 'tr:first-child > *';
	const headCells = Array.from(table.querySelectorAll(cellSelector));

	return headCells.length >= count;
}

function isNotMatchedBySelectors(selectors, element) {
	const matchesASelector = selectors.some((selector) => {
		return element.matches(selector);
	});

	return !matchesASelector;
}

function toggleOverflow(element) {
	const isOverflowing = element.scrollWidth > element.clientWidth;
	element.classList.toggle('is-overflowing', isOverflowing);

	if (isOverflowing) {
		element.setAttribute("tabindex","0");
	} else {
		element.removeAttribute("tabindex");
	}
	// missing role="region" and aria-labelledby="ID_OF_TABLE_CAPTION"
	// caption not supported in WYSIWYG :/
};

function initTable(options, table) {
	const scrollWrapper = document.createElement('div');
	scrollWrapper.classList.add(options.wrapperClass);
	table.after(scrollWrapper);
	scrollWrapper.append(table);

	if ('ResizeObserver' in window) {
		new ResizeObserver((entries) => {
			toggleOverflow(entries[0].target);
		}).observe(scrollWrapper);
	}
}

/**
 * Run plugin
 */
function exec() {
	log('Running...');

	const tablesToWrap = Array.from(document.querySelectorAll('table')).filter(
		(table) => {
			const results = tableCandidateTests.filter((test) => {
				return test(table);
			});
			return results.length === tableCandidateTests.length;
		}
	);

	tablesToWrap.forEach(initTable.bind(null, WRAPPER_OPTIONS));

	log('tablesToWrap', tablesToWrap);
}

export default exec;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/tables/table-side-scroller.js